<div class="main-header row align-items-center justify-content-between">
	
	<div class="col-12 col-sm-auto top-bar-left" *ngIf="title">
		<h1 class="header-title d-flex justify-content-center justify-content-sm-start align-items-center">
			<span (click)="onClickTitle()" [routerLink]="titleRouterLink" [class.link]="titleRouterLink || titleClick.observers.length">{{title}}</span>
			<i *ngIf="titleNext" class="fas fa-chevron-right title-seperator"></i>
      {{titleNext}}
    </h1>
	</div>
	
	<ng-content></ng-content>
	
	<div class="col col-auto d-none d-md-block top-bar-right">
		<div class="main-header-controls text-right">
			<!--<button mat-icon-button matTooltip="Notifications" color="primary"><i class="fas fa-bell"></i></button>-->
			<button mat-icon-button matTooltip="Support" color="primary"
			        routerLink="/support"
			        routerLinkActive="active"
			><i class="far fa-life-ring"></i></button>
			<button mat-icon-button matTooltip="Logout" color="primary" (click)="logout()"><i class="fas fa-sign-out"></i></button>
		</div>
	</div>

</div>
